// Get Tigris URL for user image by path
export function getProfileImageTigrisUrl(imagePath: string | null | undefined): string | null {
    if (!imagePath) return null
    
    const tigrisCname = process.env.TIGRIS_CNAME
    const uploadPath = process.env.TIGRIS_UPLOAD_PATH
    
    if (tigrisCname) {
        // imagePath is just the filename now
        return `https://${tigrisCname}/${uploadPath}/${imagePath}`
    }
    
    return null
}